import request from "@/utils/request";

// 文章详情
export function getdetail() {
  return request({
    url: "/api/agreement/get",
    method: "post",
  });
}
